import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as helperResponseHelper from "../helpers/helperResponseHelper";
import * as modelHelper from "../helpers/modelHelper";
import * as messageHelper from "../helpers/messageHelper";
import * as getterHelper from "../helpers/getterHelper";

export const processWebsocketResponse = (response, state) => {
    switch (response.event) {
        case methods.HELPER_EVENT_CONFIGURATION_UPDATED:
            if (!helperResponseHelper.isConfigurationUpdatedFormatValid(response)) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            if (state.settings.overwriteHelperConfig) {
                let syncActions = getterHelper.synchronizeHelperConfigurationToServer(
                    response.data,
                    state.settings.helperAutoCheck,
                    state.settings.helperAutoCheckInterval,
                    state.settings.helperAutoDownload,
                    state.settings.helperAutoForceInstall,
                    state.settings.helperAutoInstall,
                    state.settings.helperAutoInstallDelay,
                    state.settings.helperAutoInstallNewDbs,
                    state.settings.helperAutoNightCheck,
                    state.settings.helperAutoRebootDelay
                );

                if (syncActions.length > 0) {
                    return [
                        {
                            type: actionTypes.SAVE_HELPER_UPDATE_CONFIGURATION,
                            payload: {
                                configuration: response.data
                            }
                        },
                        ...syncActions
                    ];
                }
            }

            return [
                {
                    type: actionTypes.SAVE_HELPER_UPDATE_CONFIGURATION,
                    payload: {
                        configuration: response.data
                    }
                }
            ];
        case methods.HELPER_EVENT_SHOW_DIALOG:
            if (!helperResponseHelper.isShowDialogFormatValid(response)) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            let dialogRequests = [
                {
                    type: actionTypes.SAVE_HELPER_DIALOG,
                    payload: {
                        dialog: modelHelper.createHelperDialog(response.data)
                    }
                }
            ];

            if (!state.helper.showDialog && response.data.msgShowMinimizedWindow) {
                dialogRequests.push({
                    type: actionTypes.HELPER_SAVE_SHOW_DIALOG,
                    payload: {
                        showDialog: true
                    }
                });
            }

            return dialogRequests;
        case methods.HELPER_EVENT_UPDATE_DIALOG:
            if (!helperResponseHelper.isShowDialogFormatValid(response)) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_HELPER_DIALOG,
                    payload: {
                        dialog: modelHelper.createHelperDialog(response.data)
                    }
                }
            ];
        case methods.HELPER_EVENT_HIDE_DIALOG:
            if (!helperResponseHelper.isHideDialogFormatValid(response)) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            let hideDialogRequests = [];

            if (state.helper.dialog && response.data.dialogID === state.helper.dialog.id) {
                hideDialogRequests.push({
                    type: actionTypes.SAVE_HELPER_DIALOG,
                    payload: {
                        dialog: null
                    }
                });
            }

            return hideDialogRequests;
        case methods.HELPER_EVENT_MINIMIZE_CLIENT_APP:
            return [
                {
                    type: actionTypes.HELPER_SAVE_SHOW_DIALOG,
                    payload: {
                        showDialog: false
                    }
                }
            ];
        case methods.HELPER_EVENT_DOWNLOAD_PROGRESS:
            if (!helperResponseHelper.isDownloadProgressFormatValid(response)) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.HELPER_SAVE_DOWNLOADED_PROGRESS,
                    payload: {
                        size: response.data.zip_size,
                        downloadedSize: response.data.downloaded_size
                    }
                }
            ];
        case methods.HELPER_EVENT_SHOW_NOTIFICATION:
            return [];
        case methods.HELPER_EVENT_START_APPLICATION:
            return [];
        case methods.HELPER_EVENT_DATABASE_INFO_UPDATED:
            return [];
        case methods.HELPER_EVENT_SOFTWARE_STATUS_UPDATED:
            return [];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_HELPER_ACTION
                }
            ];
    }
};
